import { useParams } from 'react-router';
import TotalDropDown from '../../shop/selectionlists/TotalDropDown';
import TotalAmountBadges from '../common/TotalAmountBadges';
import SubNavigationLayout from './SubNavigationLayout';
import './SelectionListNavigation.scss';
import { useTranslation } from 'react-i18next';
import { useSelectionListSummary } from '../../api/selection-list/useSelectionListSummary';
import { useNavigate } from 'react-router-dom';

type Props = {
    readonly hide?: boolean;
    readonly isSticky: boolean;
};

const SelectionListNavigation = ({ hide = false, isSticky }: Props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { id = '' } = useParams<'id'>();
    const { data: listSummary, isLoading } = useSelectionListSummary(id);

    if (hide) {
        return null;
    }

    return (
        <SubNavigationLayout
            className="selection-list-nav"
            isSticky={isSticky}
            left={
                <ul className="selection-list-nav-left">
                    {!isSticky ? (
                        <li>
                            <a
                                onClick={() => {
                                    navigate(-1);
                                }}
                                className="back"
                            >
                                <i className="material-icons big">arrow_back</i>
                            </a>
                        </li>
                    ) : null}
                    <li>
                        <span>{t('selectionList.scrollHeaderTitle')}</span>
                    </li>
                    <li>
                        <i className="material-icons big">keyboard_arrow_right</i>
                    </li>
                    <li>
                        <span>{listSummary?.listName}</span>
                    </li>
                </ul>
            }
            right={
                isSticky ? (
                    <div className="selection-list-nav-right">
                        <TotalAmountBadges isLoading={isLoading} {...listSummary} className="display-flex" />
                        <TotalDropDown summary={listSummary} textTotalLine={t('components.totalDropdown.listTotal')} />
                    </div>
                ) : null
            }
        />
    );
};

export default SelectionListNavigation;
